import { useState } from 'react';
import { REACT_APP_API_ENDPOINT_SECTORES } from '../../../Domain/Settings/SettingsVariables';

import { Get } from '../../HTTP/Get';

export const FeatureListSectores = () => {
    const { AxiosGet } = Get();
    const [ sectors, setSectors] = useState([]);

    const getSectors = () => {
        AxiosGet(`${REACT_APP_API_ENDPOINT_SECTORES}`, true)
            .then((succ) => {
                setSectors(succ.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    return {
        getSectors,
        sectors
    }

}

export default FeatureListSectores;